import React, { useState } from 'react';
import { Delivery } from 'typings/models';
import {
    Card,
    CardContent,
    Typography,
    Button,
    ButtonGroup,
    Box,
    Grid2 as Grid,
    Popper,
    Grow,
    Paper,
    ClickAwayListener,
    MenuList,
    MenuItem,
    Modal,
    TextField,
} from '@mui/material';
import { LocalShipping, ArrowDropDown, CheckCircle, Cancel } from '@mui/icons-material';
import './DeliveryCard.scss';
import { useTravelContext } from 'misc/TravelContext';
import FinishedDeliveryCard from './FinishedDeliveryCard';
import { reportDeliveryProblem, completeDelivery, reopenDelivery, addCommentToDelivery } from 'api/deliveries';
import CustomButton from 'custom/buttons/CustomButton';

interface DeliveryCardProps {
    delivery: Delivery;
    onRegisterDelivery: (deliveryId: string) => void;
}

const DeliveryCard: React.FC<DeliveryCardProps> = ({ delivery, onRegisterDelivery }) => {
    const [openModal, setOpenModal] = useState(false);
    const { updateDelivery, commentCodes } = useTravelContext();


    const registerProblem = (comment: string, comment_code_id: string) => {
        reportDeliveryProblem(delivery.id, "Failed", comment, comment_code_id).then((response) => {
          console.log(response);  
            updateDelivery(response);
        });
    }
    
    const markCompleteDelivery = (comment: string) => {
        completeDelivery(delivery.id, comment).then((response) => {
            console.log(response);  
            updateDelivery(response);
        });
    }

    const markReopenDelivery = () => {
        reopenDelivery(delivery.id).then((response) => {
            console.log(response);  
            updateDelivery(response);
        });
    }
    
    const extraButtonOptions: {label: string, onClick: () => void, type: string}[] = [];

    commentCodes.map((commentCode) => {
        if (commentCode.code === "OTHER") {
          return;
        }
        extraButtonOptions.push({
            label: commentCode.short_description,
            onClick: () => registerProblem("", commentCode.id),
            type: 'default',
        });
    });

    extraButtonOptions.push({
        label: "Otro",
        onClick: () => setOpenModal(true),
        type: 'default',
    });

    const handleModalClose = () => {
        setOpenModal(false);
    };

    const [openMenu, setOpenMenu] = useState(false); 
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);   
    const [comment, setComment] = useState("");

      const handleMenuItemClick = (
        event: React.MouseEvent<HTMLLIElement, MouseEvent>,
        index: number,
      ) => {
        setSelectedIndex(index);
        setOpenMenu(false);
      };
    
      const handleToggle = () => {
        setOpenMenu((prevOpen) => !prevOpen);
      };
    
      const handleClose = (event: Event) => {
        if (
          anchorRef.current &&
          anchorRef.current.contains(event.target as HTMLElement)
        ) {
          return;
        }
    
        setOpenMenu(false);
      };

      const deliveryDescription = (
        <>
            <Typography variant="h6" component="div" gutterBottom className="delivery-card__title">
            {delivery.order.id}
        </Typography>
        <Typography variant="body1" gutterBottom>
            {delivery.order.client.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
            {delivery.order.client.address}
        </Typography>
    </>
      )

    const optionsPopper = (
        <Popper
        className="delivery-card__popper"
        open={openMenu}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {extraButtonOptions.map((option, index) => (
                    <MenuItem
                   
                    key={`${delivery.id}-${index}`}
                      selected={index === selectedIndex}
                      onClick={option.onClick}
                      className={`option-${option.type}`}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    );

    const buttonGroup =(
        <ButtonGroup
        variant="contained"
        ref={anchorRef}

    >
    <CustomButton
     onClick={() => markCompleteDelivery("Entregado")}
     className="delivery-card__button"
     >Registrar llegada</CustomButton>
    <CustomButton
        type='error'
        aria-controls={openMenu ? 'split-button-menu' : undefined}
        aria-expanded={openMenu ? 'true' : undefined}
        aria-label="select merge strategy"
        aria-haspopup="menu"
        onClick={handleToggle}
        >
        <ArrowDropDown />
        </CustomButton>
    </ButtonGroup>
    )

    const modalContent = (
        <Modal
            open={openModal}
            onClose={handleModalClose}
            className="delivery-card__modal"
        >
            <Box className="delivery-card__modal-content">
                <Typography variant="h6" gutterBottom>
                    Registrar Otro
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Ingrese su comentario"
                    variant="outlined"
                    margin="normal"
                    onChange={(e) => setComment(e.target.value)}
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={handleModalClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={() => {
                      registerProblem(comment, "7" );
                      handleModalClose();
                    }}>
                        Guardar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );



    if (delivery.status !== "In Progress" ) {
        return <FinishedDeliveryCard delivery={delivery} />
    }

    return (
        <>
            <Card className="delivery-card">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, sm: 6}}>
                            {deliveryDescription}
                        </Grid>
                        <Grid  size={{xs: 12, sm: 6}} className="delivery-card__grid-container">
                        {buttonGroup}
                        {optionsPopper}

                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {modalContent}
        </>
    );
};

export default DeliveryCard;